import "./syncBinder.scss";

import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";

import { withContainerContext } from "../../components/container/ContainerContext";
import EmptyState from "../../components/emptyState";
import FormButton from "../../components/form/FormButton";
// import FormSearchField from "../../components/form/FormSearchField";
import FormList from "../../components/form/FormList";
import ProgressBarView from "../../components/progressBar/ProgressBarView";
import TreeView from "../../components/treeView";
import interfaceIdentifiers from "../../constants/interfaceIdentifiers";
import PubSubTopics from "../../constants/pubSubTopics";
import syncApplications, { syncApplicationNamesForConstant } from "../../constants/syncApplications";
import { syncMessages } from "../../constants/syncMessages";
import { appStateOperations, appStateSelectors } from "../../modules/appState";
import { syncOperations, syncSelectors } from "../../modules/sync";
import { syncSettingsSelectors } from "../../modules/sync/settings";
import { uiStateOperations, uiStateSelectors } from "../../modules/uiState";
import { immutableRecords, PropTypeShapes } from "../../types";
import { mergeDispatchToProps } from "../../utils/codeSplit";
import selectors from "./selectors";
import SyncBinderHeader from "./SyncBinderHeader";

const SYNC_BINDER_TREE_VIEW_ID = "SYNC_BINDER_TREE_VIEW_ID";

class SyncBinder extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.onReportDimensions = this.onReportDimensions.bind(this);
    this.onSearchItemClick = this.onSearchItemClick.bind(this);
    this.renderTreeView = this.renderTreeView.bind(this);
    this.renderSearch = this.renderSearch.bind(this);
    this.renderMessages = this.renderMessages.bind(this);
    this.itemDimensions = {};
  }

  componentWillReceiveProps(_nextProps) {
    // if (nextProps.matchingItems !== this.props.matchingItems) {
    //   this._lastClickItemId = null;
    //   this._firstShiftClickSelection = null;
    // }
  }

  onReportDimensions(itemId, rect) {
    this.itemDimensions[itemId] = {
      top: rect.top,
      bottom: rect.bottom
    };
  }

  onTabClick(tabIndex) {
    this.setState({
      tabIndex
    });
  }

  onSearchItemClick(_itemId, _modifiers) {
    // if (modifiers.SHIFT && this._lastClickItemId) {
    //   // If this is the first shift click since some other click, record the current selection
    //   // as the starting point for any subsequent shift clicks
    //   if (!this._firstShiftClickSelection) {
    //     this._firstShiftClickSelection = this.props.selectedItemIds;
    //   }
    //   // Select everything from last click to current position
    //   const a = this.props.matchingItems.findIndex(obj => obj.id === this._lastClickItemId);
    //   const b = this.props.matchingItems.findIndex(obj => obj.id === itemId);
    //   const low = Math.min(a, b);
    //   const high = Math.max(a, b);
    //   const newIds = this.props.matchingItems
    //     .slice(low, high + 1)
    //     .map(obj => obj.id)
    //     .toArray();
    //   // Note that we can't simply add to selection, as we may want to select a lesser amount than was
    //   // selected with the previous shift click.
    //   // So instead we add this new selection to the original selection before the shift clicks began
    //   const allIds = this._firstShiftClickSelection.push(...newIds).toArray();
    //   this.props.onSelectItems(allIds);
    //   return;
    // }
    // // If we have a non-shift click, record it so we can use it as the starting point for any subsequent
    // // shift clicks
    // this._lastClickItemId = itemId;
    // // Erase the firt shift click so we start again the next time we do a shift click
    // this._firstShiftClickSelection = null;
    // // And then go on and handle non-shift clicks normally!
    // if (modifiers.CONTROL || modifiers.COMMAND) {
    //   if (this.props.selectedItemIds.contains(itemId)) {
    //     this.props.onRemoveFromSelection(itemId);
    //   } else {
    //     this.props.onAddToSelection(itemId);
    //   }
    // } else {
    //   this.props.onSelectItems(itemId);
    // }
  }

  onSearchItemDoubleClick(itemId, _modifiers) {
    PubSub.publish(PubSubTopics.scrollToItem, { id: itemId });
  }

  renderMessages() {
    if (this.props.syncInProgress) {
      return (
        <div className="syncBinderWarning">
          <ProgressBarView percent={this.props.syncProgressPercent} />
          <span>{this.props.syncProgressLabel}</span>
        </div>
      );
    }

    let messages = [];

    // Message priority: Conflicts > Warnings > Binder changes
    if (this.props.binderConflictCount > 0) {
      messages.push({
        value: "conflict",
        label: "You have conflicting items",
        subLabel: syncMessages.CONFLICT,
        badgeColor: this.props.binderBadgeColor,
        badgeCount: this.props.binderConflictCount
      });
    } else if (this.props.warnings.size) {
      messages = this.props.warnings.toArray();
    } else if (this.props.binderChangeCount > 0) {
      messages.push({
        value: "outOfSync",
        label: "You have out of sync items",
        subLabel: syncMessages.CHANGED,
        badgeColor: this.props.binderBadgeColor,
        badgeCount: this.props.binderChangeCount
      });
    }

    return messages.length ? (
      <div className="syncBinderWarning">
        <FormList id="syncWarnings" values={messages} canDelete={false} canAdd={false} />
      </div>
    ) : null;
  }

  renderSearch() {
    return null;

    // // @Rebecca 11/6/20: I moved this here from SyncBinderHeader, but it was never working
    // return this.props.isSyncVisible ? (
    //   <div className="syncBinderSearch searchPanelFields">
    //     <div key="searchField" className="searchPanelField searchField">
    //       <FormSearchField
    //         multiline={false}
    //         value={this.props.searchValue}
    //         placeholder="Search"
    //         autoFocus={false}
    //         hideConfigButtons={true}
    //         onChange={() => {}}
    //       />
    //     </div>
    //   </div>
    // ) : null;
  }

  renderTreeView() {
    return (
      <div className="syncBinderTree">
        {this.renderMessages()}
        <TreeView
          rootItems={this.props.binderTree}
          expandedItems={this.props.expandedItems}
          selectedItemIds={this.props.selectedItems}
          onToggleItem={this.props.onSyncItemToggled}
          onItemClick={this.props.onSyncItemClicked}
          autoEditBlankNodes={false}
          disableInlineEditing={true}
          viewId={SYNC_BINDER_TREE_VIEW_ID}
          width={this.props.containerRect.width}
        />
      </div>
    );
  }

  renderEmptyState() {
    const msg = "You have not enabled syncing yet";
    return (
      <EmptyState svg="sync" containerRect={this.props.containerRect} type="sidePanel">
        <div key="content">
          <p>{msg}</p>
          {this.props.isSyncEnabled ? null : (
            <FormButton
              primary={true}
              label={`Setup Syncing`}
              onClick={() => this.props.onOpenSettingsClick()}
              pulse={this.props.pulsateIconId === interfaceIdentifiers.SYNC_PANEL_SETTINGS}
            />
          )}
        </div>
      </EmptyState>
    );
  }

  renderLoadingState() {
    const syncAppName = syncApplicationNamesForConstant[this.props.syncApplication];
    const message = this.props.isFurtherConfigRequired
      ? "Further Sync Settings configuration is required"
      : this.props.syncApplication === syncApplications.ULYSSES && !this.props.isSyncFileMissing
        ? "Loading content from Ulysses..."
        : `${syncAppName} project could not be opened`;
    return (
      <EmptyState svg="sync" containerRect={this.props.containerRect} type="sidePanel">
        <div key="content">
          <p>{message}</p>
        </div>
      </EmptyState>
    );
  }

  render() {
    const syncNowEnabled =
      !this.props.binderConflictCount &&
      this.props.warningsCount + this.props.binderChangeCount > 0 &&
      !this.props.syncInProgress;
    return (
      <div className={`syncBinder ${!this.props.isSyncVisible ? "empty" : ""}`}>
        <SyncBinderHeader
          syncNowEnabled={syncNowEnabled}
          syncInProgress={this.props.syncInProgress}
          syncProgressLabel={this.props.syncProgressLabel}
          syncProgressPercent={this.props.syncProgressPercent}
          showTrashWarning={this.props.trashedItemCount > 0}
          onSyncClick={this.props.onSyncClick}
          onSettingsClick={this.props.onOpenSettingsClick}
          pulsateIconId={this.props.pulsateIconId}
        />
        {this.props.isSyncVisible
          ? this.renderTreeView()
          : this.props.isSyncEnabled
            ? this.renderLoadingState()
            : this.renderEmptyState()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const isSyncFileMissing = syncSelectors.getSyncFileMissing(state.present);
  const isSyncEnabled = syncSettingsSelectors.getSyncEnabled(state.present);
  const isFurtherConfigRequired = syncSettingsSelectors.isFurtherConfigRequired(state.present);
  const isSyncRepLoaded = Boolean(syncSelectors.getExternalSyncRep(state.present));
  const isSyncVisible = isSyncEnabled && isSyncRepLoaded && !isSyncFileMissing && !isFurtherConfigRequired;

  const syncInProgress = uiStateSelectors.getSyncInProgress(state.present);
  const syncProgressLabel = uiStateSelectors.getSyncProgressLabel(state.present);
  const syncProgressPercent = uiStateSelectors.getSyncProgressPercent(state.present);

  return {
    isSyncFileMissing,
    isSyncEnabled,
    isFurtherConfigRequired,
    isSyncRepLoaded,
    isSyncVisible,
    syncInProgress,
    syncProgressLabel,
    syncProgressPercent,
    syncApplication: isSyncEnabled ? syncSettingsSelectors.getSyncApplication(state.present) : null,
    binderTree: isSyncVisible ? selectors.getBinderTreeItems(state.present) : null,
    binderChangeCount: isSyncVisible ? selectors.getBinderChangeCount(state.present) : null,
    binderBadgeColor: isSyncVisible ? selectors.getBinderBadgeColor(state.present) : null,
    binderConflictCount: isSyncVisible ? selectors.getBinderConflictCount(state.present) : null,
    warnings: isSyncVisible ? selectors.getWarnings(state.present) : null,
    warningsCount: isSyncVisible ? selectors.getWarningsCount(state.present) : null,
    warningsBadgeColor: isSyncVisible ? selectors.getWarningsBadgeColor(state.present) : null,
    trashedItemCount: isSyncVisible ? selectors.getTrashedItemCount(state.present) : 0,
    syncTab: appStateSelectors.getSyncTab(state.present),
    expandedItems: appStateSelectors.getExpandedSyncItems(state.present),
    selectedItems: uiStateSelectors.getSelectedSyncItems(state.present),
    pulsateIconId: uiStateSelectors.getPulsateIconId(state.present)
  };
};

const readonlyActions = {};

const editingActions = {
  onOpenSettingsClick: uiStateOperations.showSyncSettingsModal,
  onSyncTabChange: appStateOperations.changeSyncTab,
  onSyncItemToggled: (itemId, state) => {
    return state ? appStateOperations.expandSyncItem(itemId) : appStateOperations.collapseSyncItem(itemId);
  },
  onSyncItemClicked: appStateOperations.selectSyncItems,
  onSyncClick: syncOperations.executeSync
};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, editingActions, dispatch);

SyncBinder.propTypes = {
  isSyncFileMissing: PropTypes.bool.isRequired,
  isFurtherConfigRequired: PropTypes.bool.isRequired,
  isSyncEnabled: PropTypes.bool.isRequired,
  isSyncRepLoaded: PropTypes.bool.isRequired,
  isSyncVisible: PropTypes.bool.isRequired,
  syncInProgress: PropTypes.bool.isRequired,
  syncProgressLabel: PropTypes.string,
  syncProgressPercent: PropTypes.number,
  syncApplication: PropTypes.string,
  binderTree: ImmutablePropTypes.listOf(PropTypes.instanceOf(immutableRecords.TreeViewItemRecord)),
  binderChangeCount: PropTypes.number,
  binderBadgeColor: PropTypes.string,
  binderConflictCount: PropTypes.number,
  warningsCount: PropTypes.number,
  warningsBadgeColor: PropTypes.string,
  warnings: ImmutablePropTypes.list,
  trashedItemCount: PropTypes.number,

  expandedItems: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  onSyncTabChange: PropTypes.func.isRequired,
  onSyncItemToggled: PropTypes.func.isRequired,
  onOpenSettingsClick: PropTypes.func.isRequired,
  onSyncClick: PropTypes.func.isRequired,
  selectedItems: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  onSyncItemClicked: PropTypes.func.isRequired,
  searchValue: PropTypes.string,

  pulsateIconId: PropTypes.string,

  // From containerContext
  containerRect: PropTypeShapes.flatRect.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(withContainerContext(SyncBinder));
